import { Card, Col, Empty, Table } from "antd";
import React from "react";
import styles from "./style.module.scss";
import QuestionPopover from "../questionPopover";

const DashboardTopBehaviorList = (props: {
  title: string;
  tips: string;
  loops: Array<{
    loop_id: number;
    loop_title: string;
  }>;
}) => {
  const emptyText = (
    <Empty
      style={{ paddingTop: 10, height: 165 }}
      description={<span>Not enough data yet to display results</span>}
    />
  );
  const columns = [
    {
      title: "Rank",
      dataIndex: "rank",
      width: 50,
    },
    {
      title: "Behavior",
      dataIndex: "title",
      render: renderBehaviorName,
    },
  ];
  const { tips, title, loops } = props;
  const tableData = loops
    .map((loop, index) => ({
      key: index,
      rank: index + 1,
      title: loop.loop_title,
    }))
    .slice(0, 5);

  return (
    <Col span={8}>
      <Card title={title} extra={<QuestionPopover content={tips} />}>
        <div>
          <Table
            columns={columns}
            dataSource={tableData}
            size="small"
            locale={{ emptyText }}
            pagination={false}
            rowKey={(record) => record.title + record.key}
          />
        </div>
      </Card>
    </Col>
  );
};

const renderBehaviorName = (name: string) => {
  return <span className={styles.rank_row}>{name}</span>;
};

export default DashboardTopBehaviorList;
